import React from 'react'

import './footeroverlay.css'

const FooterOverlay = () => (
	<div className='footer-overlay'>
		<div className="footer-overlay__black"></div>
		<div className="footer-overlay__img bg"></div>
	</div>
)

export default FooterOverlay